import React from "react";
import { Card, Col, Image } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
// import Swiper core and required modules
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper/core";
// Import Swiper styles
import "swiper/swiper.min.css";
import github from "../../icons/github.svg";
import liveLink from "../../icons/live.svg";
import "./ProjectDetails.css";
// install Swiper modules
SwiperCore.use([Autoplay, Pagination, Navigation]);

const ProjectDetails = (props) => {
  const { img1, img2, img3, title, live, code, text } = props.data;

  return (
    <Col xs={12} md={6} lg={4}>
      <Card className="mb-5 project-details border-0 p-2 shadow-lg p-3">
        <Carousel
        pause='hover'
        >
          <Carousel.Item>
            <Card.Img variant="top" src={img1} height={200} />
          </Carousel.Item>
          <Carousel.Item>
            <Card.Img variant="top" src={img2} height={200} />
          </Carousel.Item>
          <Carousel.Item>
            <Card.Img variant="top" src={img3} height={200} />
          </Carousel.Item>
        </Carousel>
        <Card.Body>
          <Card.Title
            className="font-weight-bolder"
            style={{ color: "#FF4C60" }}
          >
            {title}
          </Card.Title>
          <Card.Text>{text}</Card.Text>
        </Card.Body>
        <Card.Footer className="d-flex pr-3 justify-content-between align-items-center">
          <div className="d-flex">
            <h6 style={{ color: "#73DFC9" }} className="mr-2">
              Preview
            </h6>
            <a href={live} target="__blank" className="d-flex">
              <Image src={liveLink} height={25}></Image>
            </a>
          </div>
          <div className="d-flex">
            <h6 style={{ color: "#FDD778" }} className="mr-2">
              Code
            </h6>
            <a href={code} target="__blank" className="d-flex">
              <Image src={github} height={25}></Image>
            </a>
          </div>
        </Card.Footer>
      </Card>
    </Col>
  );
};

export default ProjectDetails;
